export default [

     {
          path: '/third-party-evaluation',
          name: 'ThirdPartyEvaluation',
          component: () => import("@/views/Page/ThirdPartyEvaluation/ThirdPartyEvaluation.vue"),
           meta: {
               title: '#Default# | ThirdPartyEvaluation',
          },
     }
];